module.exports = __webpack_public_path__ + "img/icon_go_home.16aea4f9.png";